import type { BraintreeClientInstance } from "../types/braintree";
import "../types/braintree";

/**
 * Shared utility for creating a Braintree client instance.
 * Used by CC Hosted Fields (useBraintreeHostedFields).
 */
export const createBraintreeClient = async (
  authorization: string
): Promise<BraintreeClientInstance> => {
  if (typeof window === "undefined" || !window.braintree?.client) {
    throw new Error("Braintree client SDK not loaded");
  }

  return window.braintree!.client.create({ authorization });
};
